module.exports = __webpack_public_path__ + "static/media/avatar-sea.491f50b4.JPG";